var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 29,
    viewBox: "0 0 178 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.413 9.58L14.603 1l4.247 8.523 9.441 1.349-6.8 6.686 1.663 9.385-8.465-4.42L6.28 27l1.55-9.384L1 10.986l9.413-1.405zM47.413 9.58L51.603 1l4.247 8.523 9.441 1.349-6.8 6.686 1.663 9.385-8.465-4.42L43.28 27l1.55-9.384-6.83-6.63 9.413-1.405zM84.413 9.58L88.603 1l4.247 8.523 9.441 1.349-6.8 6.686 1.663 9.385-8.465-4.42L80.28 27l1.55-9.384-6.83-6.63 9.413-1.405zM121.413 9.58l4.19-8.58 4.247 8.523 9.441 1.349-6.801 6.686 1.665 9.385-8.466-4.42L117.28 27l1.55-9.384-6.83-6.63 9.413-1.405zM158.413 9.58l4.19-8.58 4.247 8.523 9.441 1.349-6.801 6.686 1.665 9.385-8.466-4.42L154.28 27l1.55-9.384-6.83-6.63 9.413-1.405z",
    fill: "#D6C5FF",
    stroke: "#D6C5FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })));
}
export default SvgStars;